import * as React from "react";

function SvgEditorNoProgramming(props) {
  return (
    <svg width={375} height={118} {...props}>
      <g fillRule="evenodd">
        <path d="M155.508 75.91H260.77V2.647h-105.26v73.261" fill="#8e969f" />
        <path d="M155.508 15.7H260.77v-1.825h-105.26V15.7" fill="#7d8892" />
        <path d="M155.508 13.876H260.77V2.648h-105.26v11.228" fill="#bbc0c6" />
        <path d="M158.932 10.893h5.263V5.63h-5.263v5.263" fill="#f78d9f" />
        <path d="M164.78 10.893h5.263V5.63h-5.264v5.263" fill="#fabd1f" />
        <path d="M170.628 10.893h5.263V5.63h-5.263v5.263" fill="#b7d8f2" />
        <path d="M115 115.438h118.368V33.054H115v82.384" fill="#464e58" />
        <path d="M115 45.68h118.368V33.054H115V45.68" fill="#616b76" />
        <path d="M115 47.732h118.368V45.68H115v2.052" fill="#434a52" />
        <path
          d="M119.365 50.375a.711.711 0 11-.001 1.422.711.711 0 010-1.422zm0 59.07a.71.71 0 110 1.421.71.71 0 010-1.42zm0-3.692a.71.71 0 110 1.422.71.71 0 010-1.422zm0-3.691a.71.71 0 110 1.42.71.71 0 010-1.42zm0-3.693a.71.71 0 110 1.422.71.71 0 010-1.422zm0-3.691a.71.71 0 110 1.42.71.71 0 010-1.42zm0-3.692a.71.71 0 110 1.421.71.71 0 010-1.421zm0-3.692a.71.71 0 110 1.421.71.71 0 010-1.42zm0-3.692a.71.71 0 110 1.422.71.71 0 010-1.422zm0-7.384a.71.71 0 110 1.422.71.71 0 010-1.422zm0-3.691a.71.71 0 110 1.42.71.71 0 010-1.42zm0-3.692a.71.71 0 110 1.42.71.71 0 010-1.42zm0-3.692a.71.71 0 110 1.42.71.71 0 010-1.42zm0-3.692a.71.71 0 110 1.42.71.71 0 010-1.42zm0-3.692a.71.71 0 110 1.421.71.71 0 010-1.421zm0 22.151a.711.711 0 11-.001 1.422.711.711 0 010-1.422zm0-25.843a.71.71 0 110 1.421.71.71 0 010-1.42"
          fill="#9ac421"
        />
        <path
          d="M129.144 79.752h11.421v1.736h-11.421v-1.736zm0 14.768h11.421v1.736h-11.421V94.52zm0-22.152h11.421v1.737h-11.421v-1.737M129.144 53.91h11.421v1.735h-11.421v-1.736"
          fill="#f68656"
        />
        <path
          d="M150.982 101.903h36.98v1.737h-36.98zm-28.115-51.685h68.793v1.735h-68.793v-1.735M122.867 76.06h1.833v1.736h-1.833v-1.735"
          fill="#c0e365"
        />
        <path
          d="M159.62 105.596h7.168v1.736h-7.167v-1.736M136.965 105.596h6.176v1.736h-6.176v-1.736M135.528 101.903H148.4v1.737h-12.873v-1.737M129.144 101.903h3.804v1.737h-3.804v-1.737M174.195 98.212h8.375v1.736h-8.375v-1.736M154.138 98.212h17.476v1.736h-17.476v-1.736"
          fill="#e8e8e7"
        />
        <path d="M138.027 98.212h13.53v1.736h-13.53v-1.736" fill="#f9de1b" />
        <path d="M129.144 98.212h6.303v1.736h-6.303v-1.736" fill="#e8e8e7" />
        <path d="M149.93 90.828h6.205v1.736h-6.205v-1.736" fill="#f68313" />
        <path
          d="M136.965 90.828h10.384v1.736h-10.384v-1.736M158.569 87.136h24.77v1.736h-24.77v-1.736M144.668 87.136h11.32v1.736h-11.32v-1.736M136.965 87.136h5.123v1.736h-5.123v-1.736M162.29 83.444h1.605v1.736h-1.605v-1.736M155.583 83.444h4.127v1.736h-4.127v-1.736M136.965 83.444h8.771v1.736h-8.77v-1.736"
          fill="#e8e8e7"
        />
        <path d="M153.61 68.676h18.767v1.737H153.61v-1.737" fill="#cdccca" />
        <path
          d="M158.989 109.288h1.355v1.735h-1.355zm-12.955 0h10.375v1.735h-10.375zm-16.89 0h14.31v1.735h-14.31zm7.821-40.612h14.064v1.737h-14.064v-1.737"
          fill="#cd5629"
        />
        <path
          d="M145.72 105.596h11.32v1.736h-11.32zm2.596-22.152h4.686v1.736h-4.686zm5.82-18.46h13.333v1.737h-13.333v-1.736"
          fill="#f68313"
        />
        <path
          d="M142.2 64.985h9.356v1.736H142.2v-1.736M136.965 64.985h2.655v1.736h-2.655v-1.736M164 61.293h5.007v1.736H164v-1.736M157.292 61.293h4.128v1.736h-4.128v-1.736M150.026 61.293h4.686v1.736h-4.686v-1.736"
          fill="#cdccca"
        />
        <path d="M136.965 61.293h10.48v1.736h-10.48v-1.736" fill="#8ebae6" />
        <path
          d="M158.87 57.601h13.334v1.736h-13.333V57.6M146.936 57.601h9.354v1.736h-9.354V57.6M136.965 57.601h7.39v1.736h-7.39V57.6"
          fill="#cdccca"
        />
        <path d="M118.85 42.326h5.919v-5.918h-5.918v5.918" fill="#f1485f" />
        <path d="M125.427 42.326h5.918v-5.918h-5.918v5.918" fill="#f1a40f" />
        <path d="M132.003 42.326h5.918v-5.918h-5.918v5.918" fill="#8ebae6" />
      </g>
      <g fill="#32c27a">
        <path d="M119 104.804l134.396-93.788 1.995 2.86-134.396 93.787z" />
        <path d="M255.391 104.803L120.996 11.016 119 13.876l134.396 93.787z" />
      </g>
    </svg>
  );
}

export default SvgEditorNoProgramming;


// WEBPACK FOOTER //
// ./src/img/editor-no-programming.js